import React from 'react';

interface TextBlockProps {
    content: string;
}

export const TextBlock: React.FC<TextBlockProps> = ({ content }) => {
    const renderMarkdown = (text: string) => {
        let html = text;

        html = html.replace(/^### (.*$)/gim, '<h3 class="text-base font-semibold mt-3 mb-1">$1</h3>');
        html = html.replace(/^## (.*$)/gim, '<h2 class="text-lg font-bold mt-4 mb-2">$1</h2>');
        html = html.replace(/^# (.*$)/gim, '<h1 class="text-xl font-bold mt-5 mb-3">$1</h1>');

        html = html.replace(/\*\*(.*?)\*\*/g, '<strong class="font-semibold">$1</strong>');
        html = html.replace(/\*(.*?)\*/g, '<em class="italic">$1</em>');
        html = html.replace(/`([^`]+)`/g, '<code class="bg-gray-200 px-1 py-0.5 rounded text-sm font-mono">$1</code>');

        html = html.replace(/^\- (.*$)/gim, '<li class="ml-4">$1</li>');
        html = html.replace(/(<li.*<\/li>)/s, '<ul class="list-disc ml-6 my-2">$1</ul>');

        html = html.replace(/\n\n/g, '<br/><br/>');
        html = html.replace(/\n/g, '<br/>');

        return html;
    };

    return (
        <div
            className="prose prose-sm max-w-none text-gray-800"
            dangerouslySetInnerHTML={{ __html: renderMarkdown(content) }}
        />
    );
};
